import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-circle-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './circle-icon.component.html',
  styleUrls: ['./circle-icon.component.scss'],
})
export class CircleIconComponent {
  @Input() icon: string = '';
  @Input() color: string = '#fff';
  @Input() backgroundColor: string = '#888';
  @Input() size: number = 32; // px
}
